export class EmploymentModel {
  id: number = 0;
  startDate: string = '';
  endDate: string = '';
}
